import { Component, OnInit, ViewChild, Input, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonsService } from 'src/app/services/common.service';
import { MethodsService } from 'src/app/services/methods.service';
import { DropEvent } from 'angular-draggable-droppable';
import { InteractionsService } from 'src/app/services/interactions.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-puzzle',
  templateUrl: './puzzle.component.html',
  styleUrls: ['./puzzle.component.scss']
})
export class PuzzleComponent implements OnInit, OnDestroy {

  public completed;
  public rows: number;
  public columns: number;
  public image: string;
  public items = [];
  public randomizedItems = [];
  public imageWidth: number;
  public imageHeight: number;
  public puzzleWrapperWidth: number;
  private interactionsSubscriber;

  public interaction;

  @Input('interactionId') interactionId;

  @ViewChild('puzzle') puzzle;

  constructor(
    private interactionsService: InteractionsService,
    private methods: MethodsService
  ) {}


  // LOADING HERE CAUSE @ViewChild on OnInit cant be called.
  ngOnInit() {
    this.interactionsSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
      this.items = [];
      this.interaction = interactions.filter(interaction => interaction.id === this.interactionId)[0];
      this.methods.get('assets/data/' + this.interaction.content.configId + '.config.json').subscribe( config => {
        this.rows = config.rows;
        this.columns = config.columns;
        this.image = config.fullImage;
        this.imageWidth = config.imageWidth;
        this.imageHeight = config.imageHeight;
        this.puzzleWrapperWidth = this.puzzle.nativeElement.offsetWidth;
        this.getTheGrid();
      });
    });

    // ON CHANGE ORIENTATION RELOAD ITEMS
    window.addEventListener('orientationchange', (event: any) => {
      this.puzzleWrapperWidth = screen.width - 30;
      this.getTheGrid();
    });

  }

  getTheGrid() {
    this.items = [];
    let row = 0;
    let col = 0;
    for (let i = 0; i < this.rows * this.columns ; i++) {
      const width = this.puzzleWrapperWidth / this.columns;
      const height = ((this.puzzleWrapperWidth *  this.imageHeight) / this.imageWidth ) /  this.rows;
      this.items.push({
        id: i,
        width: width,
        height: height,
        backgroundPosition: (col * width) * -1 + 'px ' + (row * height) * -1 + 'px',
        backgroundImage: this.interaction.completed.onComplete ? this.image : null,
        opacity: 1
      });
      if (col < this.columns - 1 ) { col++; } else { col = 0; row++; }
      this.randomizedItems = this.items.map(a => ({...a})); // duplicate an array of objects
      this.randomizedItems.forEach(el => {
        el.opacity = 1;
      });
      this.randomizedItems = this.shuffle(this.randomizedItems);
    }
  }

  onDrop({ dropData }: DropEvent<string>, item: any): void {
    if (dropData === item.id) {
      console.log('item', item);
      item.backgroundImage = this.image;
      this.randomizedItems.filter(el => el.id === item.id)[0].display = 'none';
    }
    if (this.items.filter(el => el.backgroundImage).length === (this.columns * this.rows)) {
      this.interaction.completed = {
        onComplete: true,
        status: 'success'
      };
      this.interactionsService.setCompleted(this.interaction);
      this.interactionsService.updateInteraction(this.interaction);
    }
  }

  shuffle(array) {
    let currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  }

  ngOnDestroy() {
    this.interactionsSubscriber.unsubscribe();
  }

}
